import { getDateByWeekAndDay } from './dateUtils';

export const isCurrentLesson = (lesson, pairTime, currentTime, lessonDate = null) => {
  if (!pairTime || !lesson || !currentTime) return false;
  try {
    const checkDate = lessonDate || currentTime;
    const isSameDay = checkDate.getDate() === currentTime.getDate() &&
                     checkDate.getMonth() === currentTime.getMonth() &&
                     checkDate.getFullYear() === currentTime.getFullYear();
    if (!isSameDay) return false;
    const startTimeStr = pairTime.time_start || pairTime.start;
    const endTimeStr = pairTime.time_end || pairTime.end;
    if (!startTimeStr || !endTimeStr) return false;
    const [startHours, startMinutes] = startTimeStr.split(':').map(Number);
    const [endHours, endMinutes] = endTimeStr.split(':').map(Number);
    const startTime = new Date(currentTime);
    startTime.setHours(startHours, startMinutes, 0, 0);
    const endTime = new Date(currentTime);
    endTime.setHours(endHours, endMinutes, 0, 0);
    return currentTime >= startTime && currentTime <= endTime;
  } catch { return false; }
};

export const getLessonDateForWeek = (weekNumber, weekday) => {
  try { return getDateByWeekAndDay(weekNumber, weekday); } catch { return new Date(); }
};

export const isCurrentDay = (weekNumber, weekday, currentTime) => {
  try {
    const lessonDate = getDateByWeekAndDay(weekNumber, weekday);
    return lessonDate.getDate() === currentTime.getDate() &&
           lessonDate.getMonth() === currentTime.getMonth() &&
           lessonDate.getFullYear() === currentTime.getFullYear();
  } catch { return false; }
};

export const processGroupsData = (result) => {
  if (!result || !result.data) return [];
  const groupsData = result.data;
  if (Array.isArray(groupsData)) return groupsData.filter(g => g && typeof g === 'string');
  if (typeof groupsData === 'object' && groupsData.groups) return Array.isArray(groupsData.groups) ? groupsData.groups : [];
  return [];
};
